import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { Table, Modal, Checkbox } from 'rsuite'
import LoaderComponent from "../../CommonComponents/LoaderComponent"
import { checkIsAdminOrModerator, getAbbreviatedState } from "../../../services/helper"
import moment from "moment"
import { useDispatch, useStore } from "react-redux"
import { approvePartnerSubmissionAfterRerun, getPartnerSubmissions, removeMatchedSupplierForPartnerSubmission, needMoreInformationForPartnerSubmission, updatePartnerSubmissionAddress } from "../../../redux/actions/partnerSubmissions"
import { Link, useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min"
import { getLocationMastersByMasterIds, getSuppliersDataByIds } from "../../../redux/actions/vendor"
import { toast } from "../../CommonComponents/ToastComponent/toast"
import SearchModal from "../listInformationModal/search-modal"
import CreateMasterModal from "../../AssignVendorComponent/modals/create-master"
import ModalComponent from "../../CommonComponents/Modal"
import CreateMastersModal from "../listInformationModal/createMastersModal"
import QaResults from "./qaResults"
import ContextMenu from "../../CommonComponents/ContextMenu"
import RerunModal from "../listInformationModal/rerunModal"
import CheckboxComponent from "../../CommonComponents/CheckboxComponent"

const { Column, HeaderCell, Cell, Pagination } = Table

export const TableCell = ({ rowData, dataKey, mastersData = [], partnersData = [], onClick, ...props }) => {
    if (dataKey === 'state' && rowData[dataKey]) {
        rowData[dataKey] = getAbbreviatedState('', rowData[dataKey])
    }
    if (dataKey === 'createdAt') {
        const importedDate = rowData?.['createdAt'] ? moment(rowData?.['createdAt']).format('MM/DD/YYYY') : '';
        rowData[dataKey] = importedDate
    }
    if (dataKey === 'acceptanceType') {
        let masterDetails = mastersData?.find(sup => sup?.id === rowData?.matchedSupplierId)
        rowData[dataKey] = masterDetails?.acceptanceType || ''
    }

    if (dataKey === 'masterSupplierName') {
        let masterDetails = mastersData?.find(sup => sup?.id === rowData?.matchedSupplierId)
        rowData[dataKey] = <Link target="_blank" to={`/suppliers/${masterDetails?.masterSupplierId}`}>{masterDetails?.masterSupplierName}</Link>
    }

    if (dataKey === 'matchedSupplierName') {
        let supplier = mastersData?.find((sup) => sup?.id === rowData?.matchedSupplierId)
        if (supplier?.isMaster && !supplier?.masterId) {
            rowData[dataKey] = <Link target="_blank" to={`/suppliers/${supplier?.id}`}>{supplier?.suppliername}</Link>
        } else {
            rowData[dataKey] = <Link target="_blank" to={`/suppliers/relatedsupplier/${supplier?.id}`}>{supplier?.suppliername}</Link>
        }
    }

    if (dataKey === 'partnerName') {
        let partner = partnersData?.find((data) => data?.id === rowData?.partnerId)
        rowData[dataKey] = partner?.partnerName || ''
    }

    return (
        <Cell {...props} className="table-link table-cell partner-sub-table-cell text-black" id={rowData.id} title={rowData[dataKey]}>
            {rowData[dataKey]}
        </Cell>
    )
}

const PartnerSubmission = forwardRef(({ onTabChange, filters = {}, supplierPassedFromNotification }, ref) => {
    const tabs = [
        { label: 'All Suppliers', value: 'all' },
        { label: 'Unmatched Suppliers', value: 'unmatched' },
        { label: 'Matched Suppliers', value: 'matched' }
    ]

    const allColumns = [
        { name: 'suppliername', label: 'Supplier Name', sortable: true },
        { name: 'currentStatus', label: 'Status', sortable: true },
        { name: 'partnerName', label: 'Partner Name' },
        { name: 'partnerCompanyId', label: 'Company Id' },
        { name: 'address1', label: 'Address1', sortable: true },
        { name: 'address2', label: 'Address2', sortable: true },
        { name: 'city', label: 'City', sortable: true },
        { name: 'state', label: 'State', sortable: true },
        { name: 'zip', label: 'Zip', sortable: true },
        { name: 'createdAt', label: 'Date Imported', sortable: true },
        { name: 'campaignType', label: 'Service Type' },
    ]

    const unmatchedColumns = [
        { name: 'suppliername', label: 'Supplier Name', sortable: true },
        { name: 'partnerName', label: 'Partner Name' },
        { name: 'partnerCompanyId', label: 'Company Id' },
        { name: 'address1', label: 'Address', sortable: true },
        { name: 'city', label: 'City', sortable: true },
        { name: 'state', label: 'State', sortable: true },
        { name: 'zip', label: 'Zip', sortable: true },
        { name: 'email', label: 'Email' },
        { name: 'phone', label: 'Phone' },
        { name: 'url', label: 'Url' },
        { name: 'annualizedSpend', label: 'Spend', sortable: true },
        { name: 'createdAt', label: 'Date Imported', sortable: true }
    ]

    const matchedColumns = [
        { name: 'matchScore', label: 'Match Score', sortable: true },
        { name: 'currentStatus', label: 'Status', sortable: true },
        { name: 'suppliername', label: 'Supplier Name', sortable: true },
        { name: 'partnerName', label: 'Partner Name' },
        // { name: 'partnerCompanyId', label: 'Company Id' },
        { name: 'address1', label: 'Address', sortable: true },
        { name: 'city', label: 'City', sortable: true },
        { name: 'state', label: 'State', sortable: true },
        { name: 'zip', label: 'Zip', sortable: true },
        { name: 'createdAt', label: 'Date Imported', sortable: true },
        { name: 'matchedSupplierName', label: 'Matched Supplier' },
        { name: 'masterSupplierName', label: 'Master Supplier' },
        { name: 'acceptanceType', label: 'Acceptance Type' }
    ]

    const createMastersColumns = [
        { label: 'Supplier Name', name: 'suppliername' },
        { label: 'Address', name: 'address1' },
        { label: 'City', name: 'city' },
        { label: 'State', name: 'state' },
        { label: 'Zip', name: 'zip' },
        // { label: 'Card Acceptance', name: 'isAcceptCardAcceptance' },
        // { label: 'ACH Acceptance', name: 'isAcceptAchPayments' },
        // { label: 'Check Acceptance', name: 'isAcceptCheckPayments' }
    ]

    const unmatchedMenuOptions = [
        { label: 'Match to Supplier', value: 'matchSupplier' },
        { label: 'Create Master Supplier', value: 'createMasterSupplier' },
        { label: 'Rerun Database Match', value: 'rerunDatabaseMatch' },
        { label: 'Need More Information', value: 'needMoreInformation' }
    ]
    const allMenuOptions = [
        { label: 'Rerun Database Match', value: 'rerunDatabaseMatch' }
    ]

    const parseAddressFields = [
        { name: 'address1', label: 'Address1' },
        { name: 'address2', label: 'Address2' },
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State' },
        { name: 'zip', label: 'Zip' },
        { name: 'country', label: 'Country' }
    ]

    useImperativeHandle(ref, () => ({
        getTableData
    }))

    const location = useLocation()
    const dispatch = useDispatch()
    const history = useHistory()
    const store = useStore().getState()
    const {
        domain: {
            currentDomain,
        }
    } = store

    const isAdminOrMod = checkIsAdminOrModerator(currentDomain)
    const [isLoading, setIsLoading] = useState(false)
    const [isRefresh, setIsRefresh] = useState(false)
    const [currentTab, setCurrentTab] = useState(location.state?.status || 'all')
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [tableData, setTableData] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [sortColumn, setSortColumn] = useState('suppliername')
    const [sortType, setSortType] = useState('asc')
    const [searchTerm, setSearchTerm] = useState('')
    const [checked, setChecked] = useState(false)
    const [indeterminate, setIndeterminate] = useState(false)
    const [checkedKeys, setCheckedKeys] = useState([])
    const [checkedPartnerSubmissions, setCheckedPartnerSubmissions] = useState([])
    const [masterSupplierList, setMasterSupplierList] = useState([])
    const [partnersData, setPartnersData] = useState([])
    const [showCreateMastersModal, setShowCreateMastersModal] = useState(false)
    const [showAssignMasterModal, setShowAssignMasterModal] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [showRemoveModal, setShowRemoveModal] = useState(false)
    const [showCreateMasterModal, setShowCreateMasterModal] = useState(false)
    const [showQaResults, setShowQaResults] = useState(false)
    const [showContextMenu, setShowContextMenu] = useState(false)
    const [selectedPartnerSub, setSelectedPartnerSub] = useState({})
    const [showSearchOptions, setShowSearchOptions] = useState(false)
    const [showRerunModal, setShowRerunModal] = useState(false)
    const [submissionFilters, setSubmissionFilters] = useState({})
    const [parseAddressData, setParseAddressData] = useState(null)
    const [showParseAddressModal, setShowParseAddressModal] = useState(false)
    const [showFailedFullAddress, setShowFailedFullAddress] = useState(false)
    const [isUpdatingAddress, setIsUpdatingAddress] = useState(false)

    const currentStatuses = { "currentStatus": [{ "label": "Match Pending", "value": "Match Pending" }, { "label": "Unmatched - Pending QA", "value": "Unmatched - Pending QA" }, { "label": "Match in Progress", "value": "Match in Progress" }, { "label": "Matched - Pending QA", "value": "Matched - Pending QA" }, { "label": "In Sequence", "value": "In Sequence" }, { "label": "Acceptance QA Pending", "value": "Acceptance QA Pending" }] }

    useEffect(() => {
        if (supplierPassedFromNotification) {
            setSearchTerm(supplierPassedFromNotification)
            setShowFailedFullAddress(false)
            getTableData({ type: currentTab, sortColumn: 'suppliername', sortType: 'asc', limit: 10, page: 1, search: supplierPassedFromNotification, filters: {}, isGetFailedFullAddress: null})
        } else {
            history.push('/lists/partner-submissions')
            getTableData({ filters })
        }
    }, [supplierPassedFromNotification])

    const { supplierName, status } = location.state || {};

    useEffect(() => {
        setSubmissionFilters(filters);
    }, [filters])

    const handleClickTab = (tab) => {
        setCurrentTab(tab)
        setSearchTerm('')
        setPage(1)
        setLimit(10)
        setSortColumn('suppliername')
        setSortType('asc')
        setCheckedKeys([])
        setCheckedPartnerSubmissions([])
        onTabChange()
        setShowContextMenu(false)
        setShowFailedFullAddress(false)
        getTableData({ type: tab, search: '', limit: 10, page: 1, filters: currentStatuses })
    }

    const handleChangeLimit = (dataKey) => {
        setPage(1);
        setLimit(dataKey);
        getTableData({ type: currentTab, limit: dataKey, page: 1, filters: submissionFilters, isGetFailedFullAddress: !showFailedFullAddress })
    }

    const handleChangePage = (page) => {
        setPage(page)
        getTableData({ type: currentTab, limit, page, sortColumn, sortType, filters: submissionFilters, isGetFailedFullAddress: !showFailedFullAddress })
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
        getTableData({ type: currentTab, limit, page, sortColumn, sortType, search: searchTerm, filters: submissionFilters, isGetFailedFullAddress: !showFailedFullAddress })
    }

    const handleKeyDown = (e) => {
        if (e.which === 13) {
            setShowFailedFullAddress(false)
            getTableData({ type: currentTab, limit, page, sortColumn, sortType })
        }
    }

    const handleSearchClick = () => {
        if (searchTerm?.trim()) {
            setShowFailedFullAddress(false)
            getTableData({ type: currentTab, limit: 10, page: 1, sortColumn, sortType })
        }
    }

    const handleClearClick = () => {
        setSearchTerm('')
        setShowFailedFullAddress(false)
        if (searchTerm) {
            getTableData({ type: currentTab, limit, page, sortColumn, sortType, search: '' })
        }
    }

    const getTableData = async ({ type = currentTab, sortColumn = 'suppliername', sortType = 'asc', limit = 10, page = 1, search = searchTerm, filters = {}, isGetFailedFullAddress = null }) => {
        setIsLoading(true)
        dispatch(getPartnerSubmissions({
            type,
            sortColumn,
            sortType,
            limit,
            search: search?.trim(),
            offset: limit * (page - 1),
            filters,
            isGetFailedFullAddress
        })).then(async (res) => {
            if (type === 'matched' && res?.partnerSubmissions && res?.partnerSubmissions?.length > 0) {
                let finalResponse = []
                let matchedSuppliersIds = res?.partnerSubmissions?.map(data => data?.matchedSupplierId)
                if (matchedSuppliersIds?.length) {
                    await dispatch(getSuppliersDataByIds(matchedSuppliersIds, [], true)).then(async (res) => {
                        let mainMasterIds = res.filter(sup => sup?.isAcceptGlobalAcceptance === false)?.map(sup => sup?.masterSupplierId)

                        let locationMasters = []
                        if (mainMasterIds?.length > 0) {
                            locationMasters = await dispatch(getLocationMastersByMasterIds(mainMasterIds)).then((locMasters) => {
                                return locMasters
                            }).catch(() => {
                                toast.show({
                                    title: 'Warning',
                                    description: 'Failed To Get Location Masters',
                                })
                            })
                        }
                        finalResponse = res.map(sup => {
                            let locationMas = locationMasters?.find(master => master.masterId === sup.masterSupplierId)

                            if (sup?.isAcceptGlobalAcceptance === true) {
                                sup.acceptanceType = 'Global'
                            } else if (sup?.isAcceptGlobalAcceptance === null) {
                                sup.acceptanceType = 'Unknown'
                            } else if (locationMas && locationMas?.id) {
                                sup.acceptanceType = 'Location'
                            } else {
                                sup.acceptanceType = 'Selective'
                            }
                            return sup
                        })
                        setMasterSupplierList(finalResponse)
                    }).catch(() => {
                        toast.show({
                            title: 'Warning',
                            description: 'Failed To Get Master Suppliers Data!',
                        })
                    })
                }
            }

            setTableData(res?.partnerSubmissions || [])
            setTotalData(res?.total || 0)
            setPartnersData(res?.partnersData || [])
            setIsLoading(false)
        }).catch(() => {
            setTableData([])
            setTotalData(0)
            setPartnersData([])
            setIsLoading(false)
        })
    }

    const headerElements = (columns) => {
        return columns.map((col, index) => {
            return (
                <Column
                    resizable
                    sortable={col?.sortable || false}
                    key={col.name}
                >
                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <TableCell className='text-black' dataKey={col.name} mastersData={masterSupplierList} partnersData={partnersData} />
                </Column>
            )
        })
    }

    const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
        <Cell {...props} style={{ padding: 0 }}>
            <Checkbox
                value={rowData[dataKey]}
                onChange={onChange}
                checked={checkedKeys.some(item => item === rowData[dataKey])}
            />
        </Cell>
    )

    const handleCheckAll = (value, checked) => {
        let keys = checked ? tableData?.map(item => item.id) : []
        if (checked) {
            setCheckedPartnerSubmissions(tableData)
        } else {
            setCheckedPartnerSubmissions([])
        }
        setCheckedKeys(keys)
        setIndeterminate(checked)
        setChecked(checked)
    }

    const handleCheck = (value, checked) => {
        const nextCheckedKeys = checked ? [...checkedKeys, value] : checkedKeys?.filter(item => item !== value)

        setCheckedKeys(nextCheckedKeys)
        let tmpCheckedData = [...checkedPartnerSubmissions];
        if (checked) {
            tmpCheckedData = [...tmpCheckedData, tableData.find(row => row.id === value)]
        } else {
            tmpCheckedData = tmpCheckedData.filter(row => row.id !== value)
        }
        setCheckedPartnerSubmissions(tmpCheckedData)
    }

    const onSelectedListSuppliers = (type) => {
        if (checkedKeys && checkedKeys?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'Please select partner submissions!'
            })
            return
        }

        type === 'remove' ? setShowRemoveModal(true) : setShowAssignMasterModal(true)
    }

    const handleCreateMastersClick = async () => {
        setShowCreateMastersModal(true)
    }

    const handleRemoveMatchedPartnerSubmission = async () => {
        await dispatch(removeMatchedSupplierForPartnerSubmission({ partnerSubmissionIds: checkedKeys })).then(async () => {
            setCheckedKeys([])
            setShowRemoveModal(false)
            await getTableData({ type: currentTab, sortColumn, sortType, limit, page: 1, filters: submissionFilters })
            toast.show({
                title: 'Success',
                description: 'Removed Matched Supplier Successfully!'
            })
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed To Removed Matched Supplier!'
            })
        })
    }

    const handleCreateMastersCloseClick = async () => {
        setShowCreateMastersModal(false)
        if (isRefresh) {
            getTableData({ type: currentTab, sortColumn, sortType, limit, page: 1, filters: submissionFilters })
        }
    }

    const onQaResultsClose = () => {
        setShowQaResults(false)
        if (isRefresh) {
            getTableData({ type: currentTab, sortColumn, sortType, limit, page: 1, isGetFailedFullAddress: !showFailedFullAddress })
        }
    }

    useEffect(() => {
        showContextMenuItems()
    }, [currentTab, tableData])

    const showContextMenuItems = () => {
        if (currentTab === 'unmatched' || currentTab === 'all') {
            let partnerSubTable = document.getElementById(`partner-sub-table-${currentTab}`)
            if (partnerSubTable && (partnerSubTable?.id === 'partner-sub-table-unmatched' || partnerSubTable?.id === 'partner-sub-table-all')) {
                partnerSubTable.oncontextmenu = function (e) {
                    e.preventDefault()
                    const parentWithClass = e.target.closest('.rs-table-row .partner-sub-table-cell');
                    const rowId = parseInt(parentWithClass.id)
                    const rowData = tableData?.find((data) => data?.id === rowId)
                    if (partnerSubTable?.id === 'partner-sub-table-all') {
                        if (rowData?.currentStatus === 'Unmatched - Pending QA' || rowData?.currentStatus === 'Match Pending') {
                            setShowContextMenu(true)
                            setSelectedPartnerSub(rowData)
                        } else {
                            setShowContextMenu(false)
                            setSelectedPartnerSub({})
                        }
                    } else {
                        setShowContextMenu(true)
                        setSelectedPartnerSub(rowData)
                    }
                }
            }
        } else {
            setShowContextMenu(false)
            setSelectedPartnerSub({})
        }
    }

    const handleMenuItemClick = async (value) => {
        setShowContextMenu(false)
        if (value.value === 'createMasterSupplier') {
            setShowCreateMasterModal(true)
        } else if (value.value === 'matchSupplier') {
            setShowSearchOptions(true)
        } else if (value.value === 'rerunDatabaseMatch') {
            setShowRerunModal(true)
        } else if (value.value === 'needMoreInformation') {
            needMoreInformationClicked(value);
        }
    }

    const needMoreInformationClicked = async () => {
        setIsLoading(true)
        await dispatch(needMoreInformationForPartnerSubmission({ partnerSubmissionId: selectedPartnerSub.id })).then(async (res) => {
            setIsLoading(false)
            getTableData({ type: currentTab, sortColumn, sortType, limit, page, filters: submissionFilters })
            toast.show({
                title: 'Success',
                description: res.message
            })
        }).catch((error) => {
            setIsLoading(false)
            toast.show({
                title: 'Warning',
                description: error
            })
        })
    }

    const handleConfirmClick = async (partnerSubId, matchedSupplierId, status, listId = null, masterSupplierId = null) => {
        setIsLoading(true)
        if (!partnerSubId) {
            toast.show({
                title: 'Error',
                description: 'No Partner Submission Id Found'
            })
            return
        }
        if (partnerSubId && Array.isArray(partnerSubId) && partnerSubId?.length > 0) {
            for (let i = 0; i < partnerSubId?.length; i++) {
                await dispatch(await approvePartnerSubmissionAfterRerun(partnerSubId?.[i], { id: matchedSupplierId, matchScore: null }, masterSupplierId ? masterSupplierId : matchedSupplierId, status ? status : 'Manually Matched Master')).then(async () => {
                    toast.show({
                        title: 'Success',
                        description: 'Successfully matched partner submission!'
                    })
                }).catch(() => {
                    setIsLoading(false)
                    setShowCreateMasterModal(false)
                    toast.show({
                        title: 'Warning',
                        description: 'Failed to match partner submission!'
                    })
                    return
                })
            }

            await getTableData({ type: currentTab, sortColumn, sortType, limit, page: 1, filters: submissionFilters })
            setCheckedKeys([])
            setShowSearchOptions(false)
            setShowCreateMasterModal(false)
            setShowAssignMasterModal(false)
            setIsLoading(false)
        } else {
            dispatch(approvePartnerSubmissionAfterRerun(partnerSubId, { id: matchedSupplierId, matchScore: null }, masterSupplierId ? masterSupplierId : matchedSupplierId, status ? status : 'Manually Matched Master')).then(async () => {
                setIsLoading(false)
                toast.show({
                    title: 'Success',
                    description: 'Successfully matched partner submission!'
                })
                await getTableData({ type: currentTab, sortColumn, sortType, limit, page: 1, filters: submissionFilters })
                setCheckedKeys([])
                setShowSearchOptions(false)
                setShowCreateMasterModal(false)
                setShowAssignMasterModal(false)
                setShowRerunModal(false)
            }).catch(() => {
                setIsLoading(false)
                setShowCreateMasterModal(false)
                toast.show({
                    title: 'Warning',
                    description: 'Failed to match partner submission!'
                })
            })
        }
    }

    const handleCreateMaster = () => {
        setIsRefresh(true)
    }

    const onParseAddressClick = (data) => {
        setShowParseAddressModal(true)
        setParseAddressData(data)
    }

    const handleChangeAddressInfo = (colName, value) => {
        let tmpValue = value
        if (colName === 'state' || colName === 'country') {
            if (/^[a-zA-Z\s]+$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^[a-zA-Z\s]+/gi) ? value.match(/^[a-zA-Z\s]+/gi)[0] : ''
            }
        }
        setParseAddressData({ ...parseAddressData, [colName]: tmpValue })
    }

    const handleParseAddress = () => {
        const submissionData = {
            address1: parseAddressData?.address1,
            address2: parseAddressData?.address2,
            city: parseAddressData?.city,
            state: parseAddressData?.state,
            zip: parseAddressData?.zip,
            country: parseAddressData?.country,
            id: parseAddressData?.id
        }
        if (!submissionData?.address1 && !submissionData?.address2 && !submissionData?.city && !submissionData?.state && !submissionData?.zip && !submissionData?.country) {
            toast.show({
                title: 'Warning',
                description: 'Please add address field value!',
            })
            return
        }

        if (!submissionData?.id) {
            toast.show({
                title: 'Warning',
                description: 'No Partner submission Id found to update address fields!',
            })
            return
        }

        const partnerSubmissionId = submissionData?.id
        delete submissionData?.id
        setIsUpdatingAddress(true)
        dispatch(updatePartnerSubmissionAddress({ partnerSubmissionId, partnerSubmissionData: submissionData })).then(async (res) => {
            handleAddressParseClose()
            setIsUpdatingAddress(false)
            await getTableData({ type: currentTab, sortColumn, sortType, limit, page: 1, filters: submissionFilters, isGetFailedFullAddress: !showFailedFullAddress })
        }).catch(() => {
            setIsUpdatingAddress(false)
            toast.show({
                title: 'Warning',
                description: 'Failed to update partner submission address!'
            })
        })
    }

    const handleAddressParseClose = () => {
        setShowParseAddressModal(false)
        setParseAddressData(null)
    }

    const handleShowFailedFullAddress = async (value, checked) => {
        setShowFailedFullAddress(checked)
        await getTableData({ type: currentTab, sortColumn, sortType, limit, page: 1, filters: submissionFilters, isGetFailedFullAddress: !checked })
    }

    return (
        <div className="partner-submission mt-4">
            {!isAdminOrMod ? (
                <div>
                    <h3 className='text-black fw-bold'>You are not authorized to view this page!</h3>
                </div>
            ) : (
                <>
                    <div className='partner-submission-search d-flex align-items-center'>
                        <div className='d-flex align-items-center flex-grow-1 gap-3'>
                            <input
                                placeholder='Supplier name'
                                className='search-input fs-4 mb-0 w-25'
                                value={searchTerm || ''}
                                onChange={(e) => { setSearchTerm(e?.target?.value) }}
                                onKeyDown={handleKeyDown}
                            />
                            <div>
                                <button
                                    className='bg-green p-4 text-white h5 mb-0 rounded btn-lg mx-4 px-5'
                                    onClick={handleSearchClick}
                                >
                                    Search
                                </button>
                                <button className='bg-gray p-4 text-white h5 mb-0 rounded btn-lg px-5' onClick={() => { handleClearClick() }} disabled={!searchTerm?.trim()}>Clear</button>
                            </div>
                            <CheckboxComponent
                                label='Failed Full Address'
                                onChange={(checked) => { handleShowFailedFullAddress('', checked) }}
                                checked={showFailedFullAddress}
                            />
                        </div>
                        {currentTab !== 'unmatched' && (
                            <button className='pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-blue text-white' disabled={isLoading} onClick={() => setShowQaResults(true)}>QA Results</button>
                        )}
                        <button className='ms-2 pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-dark-blue text-white' disabled={isLoading}>Send To Calls</button>
                        {currentTab === 'unmatched' && (
                            <div className='ms-2 d-flex gap-2'>
                                <button className='pt-3 pb-3 p-4 h-75 rounded h4 mb-0 bg-gray text-white' onClick={() => { onSelectedListSuppliers('assign') }} disabled={isLoading}>Assign Master</button>
                                <button className='pt-3 pb-3 p-4 h-75 rounded h4 mb-0 bg-gray text-white' onClick={handleCreateMastersClick} disabled={isLoading}>Create Masters</button>
                            </div>
                        )}
                        {currentTab === 'matched' && (
                            <button className='ms-2 pt-3 pb-3 p-4 h-75 rounded h4 mb-0 bg-red text-white' onClick={() => { onSelectedListSuppliers('remove') }} disabled={isLoading}>Remove Matched Supplier</button>
                        )}
                    </div>
                    <div className='page-tabs gap-4 gap-md-5'>
                        {
                            tabs.map(tab => {
                                return <button
                                    key={tab.value}
                                    type="button"
                                    className={`page-tab me-0${currentTab === tab.value ? ' selected' : ''}`}
                                    onClick={() => { handleClickTab(tab.value) }}
                                >
                                    {tab.label}
                                </button>
                            })
                        }
                    </div>
                    <div className={`position-relative mt-4 border border-2 rounded ${isLoading ? 'loading' : ''}`}>
                        {isLoading && <LoaderComponent />}
                        <Table
                            virtualized={true}
                            autoHeight
                            affixHeader={true}
                            data={tableData}
                            className={`partner-sub-table-${currentTab}`}
                            id={`partner-sub-table-${currentTab}`}
                            rowKey="id"
                            sortColumn={sortColumn}
                            sortType={sortType}
                            onSortColumn={handleSortColumn}
                        >
                            <Column width={50} align="center" fixed>
                                <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Checkbox
                                        checked={checked}
                                        indeterminate={indeterminate}
                                        onChange={handleCheckAll}
                                    />
                                </HeaderCell>
                                <CheckCell
                                    dataKey="id"
                                    checkedKeys={checkedKeys}
                                    onChange={handleCheck}
                                />
                            </Column>
                            {headerElements(currentTab === 'all' ? allColumns : currentTab === 'matched' ? matchedColumns : unmatchedColumns)}
                            <Column fixed="right" dataKey='call' key="action" width={isAdminOrMod ? 200 : 100}>
                                <HeaderCell className='fw-bold text-black'>Action</HeaderCell>
                                <Cell className="table-action" fixed>
                                    {rowData => {
                                        return rowData?.isFullAddressParsed === false ? (
                                            <button type="button" className={`h4 mb-0 mt-0 bg-green text-white rounded pt-2 pb-2 p-4 position-relative`} style={{ bottom: '4px' }} onClick={() => { onParseAddressClick(rowData) }}>Parse Address</button>
                                        ) : (
                                            <></>
                                        )
                                    }}
                                </Cell>
                            </Column>
                        </Table>
                        <div className="my-list-table-pagination">
                            <Pagination
                                prev
                                next
                                first={true}
                                last={true}
                                maxButtons={5}
                                activePage={page}
                                showInfo
                                displayLength={limit}
                                lengthMenu={[
                                    {
                                        label: '10',
                                        value: 10,
                                    },
                                    {
                                        label: '20',
                                        value: 20,
                                    },
                                    {
                                        label: '30',
                                        value: 30,
                                    },
                                    {
                                        label: '50',
                                        value: 50,
                                    },
                                    {
                                        label: '100',
                                        value: 100,
                                    },
                                ]}
                                total={totalData}
                                onChangeLength={handleChangeLimit}
                                onChangePage={(event) => { handleChangePage(event) }}
                            />
                        </div>
                    </div>
                    {showContextMenu && (currentTab === 'unmatched' || currentTab === 'all') && (
                        <ContextMenu menuItems={currentTab === 'unmatched' ? unmatchedMenuOptions : currentTab === 'all' ? allMenuOptions : []} onMenuItemClick={handleMenuItemClick} onMenuItemBlur={() => { setShowContextMenu(false) }} />
                    )}

                    {showSearchOptions && (
                        <SearchModal
                            show={showSearchOptions}
                            onGoBack={() => { setShowSearchOptions(false) }}
                            selectedVendor={selectedPartnerSub}
                            onConfirm={handleConfirmClick}
                            isLoading={isLoading}
                            setShowCreateMasterModal={setShowCreateMasterModal}
                            // setSelectedVendor={setSelectedVendor}
                            showSearchModal={showAssignMasterModal}
                        // contactsData={contactsData}
                        />
                    )}

                    {showAssignMasterModal && (
                        <SearchModal
                            show={showAssignMasterModal}
                            onGoBack={() => { setShowAssignMasterModal(false) }}
                            onConfirm={handleConfirmClick}
                            selectedVendor={checkedKeys}
                            showSearchModal={true}
                            showCreateMasterModal={showCreateMasterModal}
                            setShowCreateMasterModal={setShowCreateMasterModal}
                            isLoading={isLoading}
                        />
                    )}

                    {showCreateMasterModal && (
                        <Modal
                            backdrop='static'
                            className="create-supplier-modal my-5 px-5"
                            show={showCreateMasterModal}
                            size="xl"
                            onClick={() => { setShowCreateMasterModal(false) }}
                            onHide={() => { setShowCreateMasterModal(false) }}
                        >
                            <Modal.Header></Modal.Header>
                            <Modal.Body>
                                <CreateMasterModal
                                    isFromList={true}
                                    listSupplier={showAssignMasterModal ? checkedKeys : selectedPartnerSub}
                                    onClose={() => { setShowCreateMasterModal(false) }}
                                    onUpdateListSupplier={handleConfirmClick}
                                    isCreatingMasterFromList={isLoading}
                                />
                            </Modal.Body>
                        </Modal>
                    )}
                    {showCreateMastersModal && (
                        <CreateMastersModal
                            show={showCreateMastersModal}
                            listId={null}
                            columns={createMastersColumns}
                            isPartnerSubmission={true}
                            handleClose={handleCreateMastersCloseClick}
                            onCreateMaster={handleCreateMaster}
                            onPage={'partnerSubmissions'}
                        />
                    )}
                    {showRemoveModal && (
                        <ModalComponent
                            size='md'
                            modalTitle='Do you want to remove the matched supplier for the selected records?'
                            open={showRemoveModal}
                            handleClose={() => { setShowRemoveModal(false) }}
                        >
                            <div className='d-flex column-gap-3'>
                                <button className='report_small_button_grey' onClick={() => { setShowRemoveModal(false) }}>Cancel</button>
                                <button className='report_small_button_danger' onClick={handleRemoveMatchedPartnerSubmission}>Remove</button>
                            </div>
                        </ModalComponent>
                    )
                    }
                    {showQaResults && (
                        <Modal
                            backdrop='static'
                            className="create-supplier-modal my-5 px-5"
                            show={showQaResults}
                            size="xl"
                            onClick={() => { onQaResultsClose() }}
                            onHide={() => { onQaResultsClose() }}
                        >
                            <Modal.Header><Modal.Title className='fw-bold text-black fs-2 mb-0'>QA Results</Modal.Title></Modal.Header>
                            <Modal.Body className='mt-3'>
                                <QaResults
                                    setIsRefresh={setIsRefresh}
                                />
                            </Modal.Body>
                        </Modal>
                    )}
                    {showRerunModal &&
                        <RerunModal
                            show={showRerunModal}
                            // showCreateMasterModal={showCreateMasterModal}
                            setShowCreateMasterModal={setShowCreateMasterModal}
                            selectedVendor={selectedPartnerSub}
                            closeRerunModalHandler={() => { setShowRerunModal(false) }}
                            page='partnerSubmission'
                            getTableData={() => { getTableData({ type: currentTab, sortColumn, sortType, limit, page: 1, filters: submissionFilters }) }}
                        />
                    }
                    {showParseAddressModal && (
                        <ModalComponent
                            size='md'
                            modalTitle='Parse Address Manually'
                            open={showParseAddressModal}
                            handleClose={() => { !isUpdatingAddress && handleAddressParseClose() }}
                            footer={<div className='d-flex column-gap-3 justify-content-end'>
                                <button className='bg-gray btn width-100 text-white fs-4' disabled={isUpdatingAddress} onClick={() => { setShowParseAddressModal(false); setParseAddressData(null) }}>Cancel</button>
                                <button className='bg-green btn width-100 text-white fs-4' disabled={isUpdatingAddress} onClick={handleParseAddress}>Parse</button>
                            </div>}
                            isLoading={isUpdatingAddress}
                        >
                            <div className='d-flex column-gap-3 modal-content'>
                                <div className='d-flex align-items-center gap-2 mb-4'>
                                    <h4 className='mb-0 text-black col-4 fw-bold'>Full Address</h4>
                                    <input
                                        className='search-input h4 mb-0'
                                        value={parseAddressData?.fullAddress || ''}
                                        disabled={true}
                                    />
                                </div>
                                <div className="parse-address-fields mt-5">
                                    {parseAddressFields?.map(col => {
                                        return <div className='d-flex align-items-center gap-2 mb-4'>
                                            <h4 className='mb-0 text-black col-4'>{col.label}</h4>
                                            <input
                                                className='search-input h4 mb-0'
                                                value={parseAddressData?.[col?.name] ? (parseAddressData?.[col?.name]?.toLowerCase() === 'null' ? '' : parseAddressData?.[col?.name]) : ''}
                                                onChange={(e) => { handleChangeAddressInfo(col.name, e.target.value) }}
                                            />
                                        </div>
                                    })}
                                </div>
                            </div>
                        </ModalComponent>
                    )}
                </>
            )}
        </div>
    )
})

export default PartnerSubmission